import { DetailedLoanCard } from "@/components/DetailedLoanCard";
import { useTrustpilotRating } from "@/hooks/useTrustpilotRatings";

interface DynamicDetailedLoanCardProps {
  provider: string;
  logo: string;
  loanAmount: string;
  nominalRate: string;
  effectiveRate: string;
  loanTerm: string;
  loanWithoutUC: string;
  responseTime: string;
  paymentSolution: string;
  link: string;
  lenderBadge?: string;
  // Trustpilot data
  entityType: string;
  entitySlug: string;
  fallbackRating: number;
  fallbackReviewCount: number;
}

/**
 * A wrapper around DetailedLoanCard that fetches dynamic Trustpilot ratings
 */
export function DynamicDetailedLoanCard({
  provider,
  logo,
  loanAmount,
  nominalRate,
  effectiveRate,
  loanTerm,
  loanWithoutUC,
  responseTime,
  paymentSolution,
  link,
  lenderBadge,
  entityType,
  entitySlug,
  fallbackRating,
  fallbackReviewCount,
}: DynamicDetailedLoanCardProps) {
  const { data: trustpilotData } = useTrustpilotRating(entityType, entitySlug);

  return (
    <DetailedLoanCard
      provider={provider}
      logo={logo}
      loanAmount={loanAmount}
      nominalRate={nominalRate}
      effectiveRate={effectiveRate}
      loanTerm={loanTerm}
      loanWithoutUC={loanWithoutUC}
      responseTime={responseTime}
      paymentSolution={paymentSolution}
      link={link}
      rating={trustpilotData?.rating ?? fallbackRating}
      reviewCount={trustpilotData?.reviewCount ?? fallbackReviewCount}
      lenderBadge={lenderBadge}
    />
  );
}
